import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const whatsappMessage = encodeURIComponent("Hi Sea Pearl Universal, I'd like to book a cleaning service | مرحباً، أود حجز خدمة تنظيف");
  const whatsappLink = `https://api.whatsapp.com/send?phone=96879964466&text=${whatsappMessage}`;

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-24">
          <div className="flex-shrink-0 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img src="https://static.readdy.ai/image/badfdf0c5f2d8472e707f25057dbcc7e/68f87dba7a9fe8a8a1cc140352171a6b.jpeg" alt="Sea Pearl Universal" className="h-20 w-auto" />
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('about')} className="text-sm font-medium text-gray-700 hover:text-[#29ABE2] transition-colors whitespace-nowrap cursor-pointer">About Us</button>
            <button onClick={() => scrollToSection('services')} className="text-sm font-medium text-gray-700 hover:text-[#29ABE2] transition-colors whitespace-nowrap cursor-pointer">Services</button>
            <button onClick={() => scrollToSection('areas')} className="text-sm font-medium text-gray-700 hover:text-[#29ABE2] transition-colors whitespace-nowrap cursor-pointer">Areas</button>
            <button onClick={() => scrollToSection('why-us')} className="text-sm font-medium text-gray-700 hover:text-[#29ABE2] transition-colors whitespace-nowrap cursor-pointer">Why Us</button>
            <button onClick={() => scrollToSection('contact')} className="text-sm font-medium text-gray-700 hover:text-[#29ABE2] transition-colors whitespace-nowrap cursor-pointer">Contact</button>
          </nav>

          <div className="hidden md:flex items-center space-x-3">
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="px-5 py-2.5 bg-[#8DC63F] text-white text-sm font-medium rounded-full hover:bg-[#7AB62F] transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-whatsapp-line mr-2"></i>WhatsApp
            </a>
            <a href="tel:+96879964466" className="px-5 py-2.5 bg-[#29ABE2] text-white text-sm font-medium rounded-full hover:bg-[#1E8FBF] transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-phone-line mr-2"></i>Call Now
            </a>
          </div>

          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden text-gray-700 cursor-pointer">
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-4 py-4 space-y-3">
            <button onClick={() => scrollToSection('about')} className="block w-full text-left py-2 text-sm font-medium text-gray-700 hover:text-[#29ABE2] cursor-pointer">About Us</button>
            <button onClick={() => scrollToSection('services')} className="block w-full text-left py-2 text-sm font-medium text-gray-700 hover:text-[#29ABE2] cursor-pointer">Services</button>
            <button onClick={() => scrollToSection('areas')} className="block w-full text-left py-2 text-sm font-medium text-gray-700 hover:text-[#29ABE2] cursor-pointer">Areas</button>
            <button onClick={() => scrollToSection('why-us')} className="block w-full text-left py-2 text-sm font-medium text-gray-700 hover:text-[#29ABE2] cursor-pointer">Why Us</button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left py-2 text-sm font-medium text-gray-700 hover:text-[#29ABE2] cursor-pointer">Contact</button>
            <div className="flex flex-col space-y-2 pt-3">
              <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="px-5 py-2.5 bg-[#8DC63F] text-white text-sm font-medium rounded-full hover:bg-[#7AB62F] transition-colors text-center whitespace-nowrap cursor-pointer">
                <i className="ri-whatsapp-line mr-2"></i>WhatsApp
              </a>
              <a href="tel:+96879964466" className="px-5 py-2.5 bg-[#29ABE2] text-white text-sm font-medium rounded-full hover:bg-[#1E8FBF] transition-colors text-center whitespace-nowrap cursor-pointer">
                <i className="ri-phone-line mr-2"></i>Call Now
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}